import { FC, ReactElement } from 'react'

import { getUserFullName } from '@/helpers/getUserFullName'
import { ShiftPlanningCommentResource } from '@/models'

import './Comment.scss'

interface CommentProps {
    comment: ShiftPlanningCommentResource
}

export const Comment: FC<CommentProps> = ({ comment }): ReactElement => {
    const userFullName = getUserFullName(comment.owner)

    return (
        <tr className="comment">
            <td>
                {userFullName ? `${userFullName}: ` : ''}
                {comment.body}
            </td>
        </tr>
    )
}
